













































































import Vue from 'vue';
// import brand, { Brand } from '@/modules/exhibitor/brand';
// import favorite, { FavoriteBrand } from '@/modules/buyer/favorite';
// import contact from '@/modules/analysis/contact';
import {
  brand,
  BrandFavoriteListItem,
} from 'mostra';

export type DataType = {
  brandFavoriteList: BrandFavoriteListItem[];
  currentPage: number;
  perPage: number;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-analysis-favorite-index',
  data(): DataType {
    return {
      brandFavoriteList: [],
      currentPage: 1,
      perPage: 40,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.brandFavoriteList = await brand.loadBrandFavoriteList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      this.brandFavoriteList = await brand.loadBrandFavoriteList(this.perPage, 1);
    } catch (error: any) {
      this.$error('ブランドの取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
  methods: {
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.brandFavoriteList = await brand.loadBrandFavoriteList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllBrands() {
      this.total = await brand.countAllBrands();
    },
  },
});
